import { render, staticRenderFns } from "./ListItemInfo.vue?vue&type=template&id=475a2624&"
import script from "./ListItemInfo.vue?vue&type=script&lang=js&"
export * from "./ListItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./ListItemInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports